import { Quota } from '../models/survey-quota.model';
import { NESTED_QUOTA_DEFAULT_GROUP_ID } from '../constants/survey-quotas.constants';

export class SurveyNestedQuotas {
  constructor(private readonly _quotas: readonly Quota[]) {}

  public groupIds(): readonly string[] {
    return [...new Set(this._quotas.map((quota) => this._groupId(quota)))];
  }

  public withGroup(groupId: string): readonly Quota[] {
    return this._quotas.filter((quota) => this._groupId(quota) === groupId);
  }

  private _groupId(quota: Quota): string {
    return quota.groupKey || NESTED_QUOTA_DEFAULT_GROUP_ID;
  }
}
